import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "join-team-wrapper" }
const _hoisted_2 = { class: "tips" }

import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGroupStore } from '@/store/group'
import { useMessage } from 'naive-ui'

// 判断是否登录
import { useUserStore } from '@/store/user'
import { ACCOUNT } from '@plus/env'
import useTeamShare from '@teams/common/hooks/useTeamShare'
import useAppDialog from '../appDialog/useAppDialog'
import handleResponseError from '@teams/common/hooks/useResponseError'


export default /*#__PURE__*/_defineComponent({
  __name: 'JoinTeam',
  emits: ['close'],
  setup(__props, { expose, emit }) {

const { inviteInfo, joinTeam, joinTeamByKey, settingInfo } = useTeamShare()
const groupStore = useGroupStore()
const message = useMessage()
const appDialog = useAppDialog()

const { t } = useI18n()
// eslint-disable-next-line
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return t(`components.dialog.joinTeam.${key}`, ...params)
}
const needApprove = computed(() => {
  return settingInfo.value.share_need_approve
})
const i18n = reactive({
  tips: computed(() => {
    return needApprove.value ? $tt('tipsNeedApprove') : $tt('tips')
  })
})

const join = async function () {
  // 判断是否登录
  const userStore = useUserStore()
  if (!userStore.userId) {
    const inviteUrl = inviteInfo.value?.invite_url
    const cbUrl =
      groupStore.isFromInviteUrl && inviteUrl ? inviteUrl : location.href
    window.location.href = `${ACCOUNT}?cb=${cbUrl}`
    return
  }
  const invKey = inviteInfo.value?.invite_link?.key
  const { id: groupId } = groupStore.current
  try {
    // 根据有无邀请key（有可以为分享落地页）使用不同加入团队接口
    if (invKey) {
      await joinTeamByKey(invKey)
    } else {
      await joinTeam()
    }
    if (needApprove.value) {
      message.success($tt('apply'), { duration: 3000 })
    } else {
      message.success($tt('joinSuccess'))
      setTimeout(() => {
        const url = location.origin + `/${groupId}`
        window.location.href = url
      }, 3000)
    }
    emit('close')
  } catch (e: { response: unknown }) {
    const result = e.response?.data?.result
    if (['joinGroupWaitingApprove'].includes(result)) {
      message.success($tt('apply'), { duration: 3000 })
      emit('close')
      return
    }
    // 如果添加成员时抛出UserNotInCompany错误，则是企业外部人员，弹出当前空间仅支持企业成员申请的弹框，可以选择切换账号
    if (result === 'UserNotInCompany') {
      appDialog.show({
        name: 'ForbiddenJoin',
        componentProps: {
          avatar: groupStore.current.companyLogo,
          companyName: groupStore.current.companyName
        }
      })
      emit('close')
      return
    }
    handleResponseError(e)
  }
}

const onOk = async () => {
  await join().catch()
  return false
}

expose({
  onOk
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(i18n.tips), 1)
  ]))
}
}

})